export const h = {
  set_up: "Let's get your account set up",
  Email: "Email Address",
  pwd: "Password",
  c_pwd: "Confirm Password",
  v_code: "Vertify Code",
  s_code: "Send Code",
  regist: "Regist",
  have_an_account: "Let's get your account set up",
  login: 'Log In',
  create_an_account: "Create an Account",
  forget_password: "Forget Password?"
}